<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Irish Fireworks</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#the-first-spark">The First Spark</a></li><li id="toc-li-5"><a href="#/text/ch005#incipient">Incipient</a></li><li id="toc-li-6"><span href="#/text/ch006#oxygen" title="Link target outside of Sample">Oxygen</span></li><li id="toc-li-7"><span href="#/text/ch007#fuel" title="Link target outside of Sample">Fuel</span></li><li id="toc-li-8"><span href="#/text/ch008#spark" title="Link target outside of Sample">Spark</span></li><li id="toc-li-9"><span href="#/text/ch009#ignition" title="Link target outside of Sample">Ignition</span></li><li id="toc-li-10"><span href="#/text/ch010#growth" title="Link target outside of Sample">Growth</span></li><li id="toc-li-11"><span href="#/text/ch011#flashover" title="Link target outside of Sample">Flashover</span></li><li id="toc-li-12"><span href="#/text/ch012#heat" title="Link target outside of Sample">Heat</span></li><li id="toc-li-13"><span href="#/text/ch013#burning" title="Link target outside of Sample">Burning</span></li><li id="toc-li-14"><span href="#/text/ch014#decay" title="Link target outside of Sample">Decay</span></li><li id="toc-li-15"><span href="#/text/ch015#time" title="Link target outside of Sample">Time</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?45c3ce5d